import { Badge, type BadgeProps, cn } from "@au-schein-de/au-ui-library";
import type { JSX } from "react";
import type { CannabinoidLabelVariant } from "./use-adaptive-cannabinoid-label.hook";

const carouselCannabinoidBadgePaddingClassName = "p-1";

type ProductCardCannabinoidBadgeProps = {
	label: string;
	title: string;
	variant: CannabinoidLabelVariant;
	size: BadgeProps["size"];
	testId: string;
	compactPadding?: boolean;
};

/**
 * Content-sized THC/CBD badge. It never stretches beyond its label; it only
 * shrinks and truncates when even the short labels overflow the badge row.
 */
export function ProductCardCannabinoidBadge({
	label,
	title,
	variant,
	size,
	testId,
	compactPadding = false,
}: ProductCardCannabinoidBadgeProps): JSX.Element {
	return (
		<Badge
			size={size}
			className={cn(
				"min-w-0 overflow-hidden",
				compactPadding && carouselCannabinoidBadgePaddingClassName,
			)}
			title={title}
			data-testid={testId}
			data-cannabinoid-label={variant}
		>
			<span className="block min-w-0 truncate" data-testid={`${testId}-label`}>
				{label}
			</span>
		</Badge>
	);
}
